<template>
  <div>
    <template v-if="loading"></template>
    <template v-else-if="line_error">
      <h1>Not Authorized</h1>
    </template>
    <template v-else>
      <header>
        <nav id="header">
          <ul class="nav left">
            <li style="border-right: 1px solid rgb(101, 101, 101)">
              <router-link to="/allbots" class="navbar-brand">
                <img src="/static/img/logo-small.png" alt style="width: 60px" />
              </router-link>
            </li>
          </ul>
        </nav>
      </header>

      <div id="content">
        <div class="container" style="margin-top: 20px">
          <order-summary-mobile
            class="hidden-sm hidden-md hidden-lg"
            v-model="filterSummary"
            @onExport="exportOrderSummary"
            @onRefresh="getOrderSummary"
            @updateOrder="updateOrder"
            @onChangeStatus="onChangeStatus"
          >
            <div class="col-xs-12" slot="filter" style="margin-bottom: 15px">
              <select class="form-control" v-model="filterStatus" @change="getOrderSummary">
                <option value="all">All{{ badge.all > 0 ? ' (' + badge.all + ')' : '' }}</option>
                <option value="ordered">
                  Ordered{{ badge.ordered > 0 ? ' (' + badge.ordered + ')' : '' }}
                </option>
                <option value="paid">
                  Paid{{ badge.paid > 0 ? ' (' + badge.paid + ')' : '' }}
                </option>
                <option value="shipped">
                  Shipped{{ badge.shipped > 0 ? ' (' + badge.shipped + ')' : '' }}
                </option>
                <option value="Canceled">
                  Canceled{{ badge.canceled > 0 ? ' (' + badge.canceled + ')' : '' }}
                </option>
              </select>
            </div>
            <date-range-picker
              slot="datepicker"
              v-model="selectedDate"
              ref="rangeDatePicker"
              @onSelectedDate="onSelectedDate"
            ></date-range-picker>
          </order-summary-mobile>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import $ from 'jquery'
import DateRangePicker from '@/components/elements/DateRangePicker'
import api from '@/api'
import OrderSummaryMobile from './OrderSummaryMobile'
import moment from 'moment'

export default {
  data: function () {
    return {
      loading: true,
      filterStatus: 'all',
      selectedDate: {
        start: moment().subtract(1, 'months').toDate(),
        end: moment().toDate()
      },
      display_name: null,
      lineid: null,
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      line_error: false
    }
  },
  components: {
    DateRangePicker,
    OrderSummaryMobile
  },
  computed: {
    filterSummary: function () {
      let vm = this
      let orders = []
      vm.badge = {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      }
      vm.badge.all = vm.summary.length

      $.each(vm.summary, function (index, val) {
        vm.badge[val.status] += 1
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      return orders
    }
  },
  mounted: function () {
    var vm = this
    if (this.$route.query.datefrom) {
      vm.selectedDate = {
        start: moment(this.$route.query.datefrom).toDate(),
        end: moment().toDate()
      }
    }
    if (process.env.NODE_ENV === 'development') {
      vm.lineid = 'U3f1e5f8f6c6d8245863376ead18d6824'
      vm.getOrderSummary()
      vm.loading = false
    } else {
      liff.init(
        (data) => {
          liff
            .getProfile()
            .then((profile) => {
              vm.display_name = profile.displayName
            })
            .catch((err) => {
              vm.line_error = true
              setTimeout(() => {
                vm.loading = false
              }, 1000)
            })

          vm.lineid = data.context.userId
          vm.getOrderSummary()
          vm.loading = false
        },
        (err) => {
          vm.line_error = true
          setTimeout(() => {
            vm.loading = false
          }, 1000)
        }
      )
    }
  },
  filters: {
    formatdate: function (value) {
      return moment(value).format('YYYY/MM/DD h:mm:ss a')
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  methods: {
    changeStatus: function (value) {
      this.filterStatus = value
    },
    getOrderSummary: function () {
      let vm = this
      let data = {
        lineid: vm.lineid,
        datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD'),
        status: vm.filterStatus
      }
      vm.$store.dispatch('loading')
      api.getOrderSummary(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        if (response.data) {
          vm.summary = response.data
          if (vm.filterStatus == 'all') {
            vm.badge = {
              all: response.all,
              canceled: response.canceled,
              ordered: response.ordered,
              paid: response.paid,
              shipped: response.shipped
            }
          }
        }
        vm.$store.dispatch('loading')
      })
    },
    onSelectedDate: function (value) {
      // console.log(value)
      return false
      let date = {
        start: moment(value.start).format('YYYY-MM-DD'),
        end: moment(value.end).format('YYYY-MM-DD')
      }

      this.selectedDate = date
      this.getOrderSummary()
    },
    onChangeStatus: function (index) {
      let vm = this
      vm.updateOrder(index, function () {})
    },
    sendTrackingNo: function (index) {
      this.updateOrder(index)
    },
    updateOrder: function (id, callback) {
      let vm = this
      vm.$store.dispatch('loading')
      let data = vm.summary.find(function (element) {
        return element.id == id
      })
      data.lineid = vm.lineid
      api.editOrderSummary(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        callback()
        vm.$store.dispatch('loading')
      })
    },
    exportOrderSummary: function () {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''

      csvContent += 'Order No.,Products,Name and Address,Price,Tracking No.,Created Date' + '\r\n'
      $.each(vm.summary, function (index, val) {
        let row =
          '"' +
          val.id +
          '","' +
          val.productdetail.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          val.nameaddress.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          numeral(val.amount).format('0,0.00').toString() +
          '","' +
          val.trackingno.replace(/\r?\n|\r/g, ' / ') +
          '","' +
          moment(val.timestamp).format('DD/MM/YYYY') +
          '"'
        csvContent += row + '\r\n'
      })

      var encodedUri = header + encodeURI(csvContent)
      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'order_summary_' + moment().format('YYYY_MM_DD') + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderSummaryLine.vue